import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { eTypeResult } from 'src/app/models/common/enumModel';
import { IDeshabilitarAccesosBatchModel } from 'src/app/models/interfaces/accesos/IDeshabilitarAccesosBatchModel';
import { AccesoPersonaService } from 'src/app/services/acceso-personal/acceso-persona.service';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';

@Component({
  selector: 'app-deshabilitar-accesos-personal-dialog',
  templateUrl: './deshabilitar-accesos-personal-dialog.component.html',
  styleUrls: ['./deshabilitar-accesos-personal-dialog.component.css']
})
export class DeshabilitarAccesosPersonalDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DeshabilitarAccesosPersonalDialogComponent>,
    private accesoPersonalService: AccesoPersonaService,
    private alertDialogService: AlertDialogService,
    @Inject(MAT_DIALOG_DATA) public model: IDeshabilitarAccesosBatchModel
  ) { }

  ngOnInit(): void {
  }

  Save(): void {
    this.accesoPersonalService.deshabilitar(this.model).subscribe(result => {
      if (result.type != eTypeResult.SUCCESS) {
        this.alertDialogService.open(result.message);
      }
      else {
        this.dialogRef.close(true);
        this.alertDialogService.open('Se bloquearon los accesos de las personas seleccionadas.');
      }
    });
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  esValido(): boolean {
    if (this.model.comentarios == "")
      return true;
    else
      return false;
  }
}
